"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _useRedirect = _interopRequireDefault(require("@sprinx/react-routes/useRedirect"));

var _AppBarActionCart = _interopRequireDefault(require("@sprinx/react-shopping-cart/AppBarActionCart"));

var _Badge = _interopRequireDefault(require("@material-ui/core/Badge"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _clsx = _interopRequireDefault(require("clsx"));

var _pickReactKnownProp = require("pick-react-known-prop");

var _AppSettingsProvider = require("../../app/AppSettingsProvider/AppSettingsProvider");

var _useProductComparisonContext = _interopRequireDefault(require("../../products/useProductComparisonContext"));

var _BasketIcon = _interopRequireDefault(require("../../icons/BasketIcon"));

var _useShoppingRegion = _interopRequireDefault(require("../../shop/useShoppingRegion"));

var _AppBarActionRegion = _interopRequireDefault(require("./AppBarActionRegion"));

var _AppBarActionGlobalSearchComposed = _interopRequireDefault(require("./AppBarActionGlobalSearchComposed"));

var _useCountriesFlag = _interopRequireDefault(require("./useCountriesFlag"));

var _AppBarActionUser = _interopRequireDefault(require("./AppBarActionUser"));

var _CompareIcon = _interopRequireDefault(require("./CompareIcon"));

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingLeft: theme.spacing(3)
    },
    about: {
      color: theme.palette.common.black,
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2)
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap'
    },
    icon: {
      fill: theme.palette.common.black,
      width: 24,
      height: 24
    },
    compareIcon: {
      fill: theme.palette.common.black
    },
    iconWrapper: {
      width: 48,
      height: 48
    },
    iconContainer: {
      '& svg': {
        width: 24,
        height: 24,
        fill: theme.palette.common.black
      }
    }
  };
}, {
  name: 'AppBarActions'
});

var AppBarActions = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      variant = _ref.variant,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "variant"]);
  var classes = useStyles({
    classes: pClasses,
    className: className
  });

  var _useProductComparison = (0, _useProductComparisonContext.default)(),
      comparedProducts = _useProductComparison.comparedProducts;

  var setRedirect = (0, _useRedirect.default)();
  var t = (0, _useTranslate.default)();

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      chooseLang = _React$useState2[0],
      setChooseLang = _React$useState2[1];

  var region = (0, _useShoppingRegion.default)();
  var countriesFlag = (0, _useCountriesFlag.default)();
  var currentRegion = countriesFlag.find(function (i) {
    return i.region === region;
  });
  var locale = (0, _AppSettingsProvider.useAppSettingsLocale)();
  var routeUrl = (0, _AppSettingsProvider.useAppSettingsRouteUrl)();
  return !chooseLang ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className),
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_AppBarActionGlobalSearchComposed.default, {
    label: "Search items",
    variant: variant
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    to: t('appBarActions/aboutHref'),
    className: classes.about
  }, t('appBarActions/about')), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: t('appBarActions/compare')
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: function onClick() {
      return setRedirect('/compare');
    },
    className: classes.iconWrapper
  }, /*#__PURE__*/_react.default.createElement(_Badge.default, {
    badgeContent: comparedProducts.length,
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_CompareIcon.default, {
    className: classes.compareIcon
  })))), /*#__PURE__*/_react.default.createElement(_AppBarActionUser.default, {
    variant: variant,
    path: "/profile"
  }), /*#__PURE__*/_react.default.createElement(_AppBarActionCart.default, {
    variant: variant,
    path: routeUrl('cart', {
      locale: locale,
      params: {}
    }),
    IconComponent: _BasketIcon.default,
    IconComponentProps: {
      className: classes.icon
    }
  }), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: t('appBarActionRegion/changeRegion')
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: function onClick() {
      return setChooseLang(true);
    },
    className: classes.iconContainer
  }, currentRegion.icon)))) : /*#__PURE__*/_react.default.createElement(_AppBarActionRegion.default, {
    onChange: setChooseLang
  });
});

AppBarActions.displayName = 'AppBarActions';
process.env.NODE_ENV !== "production" ? AppBarActions.propTypes = {
  classes: _propTypes.default.shape({
    about: _propTypes.default.string,
    compareIcon: _propTypes.default.string,
    container: _propTypes.default.string,
    icon: _propTypes.default.string,
    iconContainer: _propTypes.default.string,
    iconWrapper: _propTypes.default.string,
    language: _propTypes.default.string,
    languageIcon: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  variant: _propTypes.default.oneOf(['none', 'menuItem', 'standalone'])
} : void 0;
AppBarActions.defaultProps = {
  classes: undefined,
  className: undefined,
  variant: 'standalone'
};
var _default = AppBarActions;
exports.default = _default;